class CustomFieldService {
    OPEN_EXPLORE_POINT = 'open_explore_point';
    OPEN_EXPLORE_TRAIL = 'open_explore_trail';
    NEWS = 'news';
    ACHIEVEMENT = 'achievement';
    filter(customFields, type) {
        if (customFields) {
            return customFields.filter(cf => {
                return cf.entity_name === type
            })
        } else {
            return [];
        }
    }
}

export default new CustomFieldService();




// WEBPACK FOOTER //
// src/services/customfield.js